import { create } from "zustand";
import { fetchMainEmployeesListService } from "../services/mainEmployeeListServices";

export const useMainEmployeeStore = create((set) => ({
  mainEmployeeList: [],
  loading: false,
  fetchMainEmployees: async (projectId) => {
    await fetchMainEmployeesListService(set, projectId);
  },
}));
